import { createContext, type PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';

type ContentArticleBannerContext = {
  hasDismissedContentArticleBanner: boolean;
  markContentArticleBannerAsDismissed: () => void;
};

const contentArticleBannerContext = createContext<ContentArticleBannerContext>({
  hasDismissedContentArticleBanner: false,
  markContentArticleBannerAsDismissed: () => undefined,
});

const ContentArticleBannerProvider = ({ children }: PropsWithChildren) => {
  const [hasDismissedContentArticleBanner, setHasDismissedContentArticleBanner] = useState(false);
  const markContentArticleBannerAsDismissed = useCallback(() => setHasDismissedContentArticleBanner(true), []);

  const value = useMemo(
    () => ({
      hasDismissedContentArticleBanner,
      markContentArticleBannerAsDismissed,
    }),
    [hasDismissedContentArticleBanner, markContentArticleBannerAsDismissed]
  );

  return <contentArticleBannerContext.Provider value={value}>{children}</contentArticleBannerContext.Provider>;
};

const useContentArticleBannerContext = () => useContext(contentArticleBannerContext);

export { ContentArticleBannerProvider, useContentArticleBannerContext };
